export const SimpleItemColorRules = Object.freeze({
    text: {
        // TODO DELETE
        default: 'selected',
        state: 'idle',

        // NEW
        idle: {
            default: 'selected',
        },
        hover: {
            default: 'vibrant',
            fallbacks: ['contrast', 'selected'],
        }
    },
    // TODO DELETE
    textHover: {
        default: 'vibrant',
        fallbacks: ['contrast', 'selected'],
        state: 'active'
    }
})
export const FilledItemColorRules = Object.freeze({
    fill: {
        // TODO DELETE
        default: 'selected',
        state: 'idle',

        // NEW
        idle: {
            default: 'selected',
        },
        hover: {
            default: 'vibrant',
            fallbacks: ['contrast', 'selected'],
        }
    },
    text: {
        // TODO DELETE
        default: 'contrast',
        state: 'idle',

        // NEW
        idle: {
            default: 'contrast',
        },
        hover: {
            default: 'contrast',
            relativeToKey: {type: 'fill', state: 'hover'}
        }
    },
    // TODO DELETE
    fillHover: {
        default: 'vibrant',
        fallbacks: ['contrast', 'selected'],
        state: 'hover'
    },
    // TODO DELETE
    textHover: {
        default: 'contrast',
        state: 'hover',
        relativeToKey: 'buttonFillHover'
    }
})
export const OutlinedItemColorRules = Object.freeze({
    fill: {
        // TODO DELETE
        default: 'background',
        colorStyleKey: 'background',
        state: 'idle',

        // NEW
        idle: {
            default: 'background',
            colorStyleDependency: {key: 'background', type: 'fill', state: 'idle'},
        },
        hover: {
            default: 'background',
            colorStyleDependency: {key: 'background', type: 'fill', state: 'idle'},
        }
    },
    outline: {
        // TODO DELETE
        default: 'selected',
        state: 'idle',

        // NEW
        idle: {
            default: 'selected',
        },
        hover: {
            default: 'vibrant',
            fallbacks: ['contrast', 'selected'],
        }
    },
    text: {
        // TODO DELETE
        default: 'selected',
        state: 'idle',

        // NEW
        idle: {
            default: 'selected',
        },
        hover: {
            default: 'vibrant',
            fallbacks: ['contrast', 'selected'],}
    },

    // TODO DELETE
    fillHover: {
        default: 'background',
        colorStyleKey: 'background',
        state: 'hover'
    },
    // TODO DELETE
    outlineHover: {
        default: 'vibrant',
        fallbacks: ['contrast', 'selected'],
        state: 'hover'
    },
    // TODO DELETE
    textHover: {
        default: 'vibrant',
        fallbacks: ['contrast', 'selected'],
        state: 'hover'
    }
})

export const ContactFormColorRules = Object.freeze({
    outline: {
        // TODO DELETE
        default: 'selected',
        state: 'idle',

        // NEW
        idle: {
            default: 'selected',
        }

    },
    text: {
        // TODO DELETE
        default: 'paragraph',
        colorStyleKey: 'p1',
        state: 'idle',

        // NEW
        idle: {
            default: 'paragraph',
            colorStyleDependency: {key: 'p1', type: 'text', state: 'idle'},
        }
    }
})
export const ProcessStepColorRules = Object.freeze({
    fill: {
        active: {
            default: 'selected',
        }
    },
    outline: {
        // TODO DELETE
        default: 'divider-line',
        colorStyleKey: 'dividerLine',
        state: 'idle',

        // NEW
        idle: {
            default: 'divider-line',
            colorStyleDependency: {key: 'dividerLine', type: 'fill', state: 'idle'},
        },
    },
    text: {
        // TODO DELETE
        default: 'headings',
        colorStyleKey: 'h1',
        state: 'idle',

        // NEW
        idle: {
            default: 'headings',
            colorStyleDependency: {key: 'h1', type: 'text', state: 'idle'},
        },
        active: {
            default: 'contrast',
            relativeToKey: {type: 'fill', state: 'active'}
        }
    },

    // TODO DELETE
    fillActive: {
        default: 'selected',
        state: 'active'
    },
    // TODO DELETE
    textActive: {
        default: 'contrast',
        state: 'active',
        relativeToKey: 'processFillActive'
    }
})